import React from "react";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import { FullPagePaperLayout } from "../Layouts/FullPagePaperLayout";
import { PageBreadcrumbs, PageTitle, PageActions, PageSubtitle } from "../Layouts/components/PageTitleContainer";
import { MovementAction } from "types/locationManagement/movementAction";
import { GridValueGetterParams } from "@mui/x-data-grid-pro";
import { RevivnDatabaseDataGrid } from "components/DataGrid/RevivnDatabaseDataGrid";
import { linkColDef } from "components/DataGrid/columnDefs/linkColDef";
import { actionColDef } from "components/DataGrid/columnDefs/actionColDef";

const MovementActionList: React.FC = () => {
  return (
    <FullPagePaperLayout>
      <PageBreadcrumbs links={[{ label: "Admin" }, { label: "Movement Actions", path: "/movement-actions" }]} />
      <PageTitle>Movement Actions</PageTitle>
      <PageSubtitle>
        Create an action that occurs when inventory move between location types. Ex: When inventory moves to RESL,
        change state = resellable.
      </PageSubtitle>
      <PageActions>
        <Button variant="contained" color="primary" component={Link} to="/movement-actions/new">
          Create Movement Action
        </Button>
      </PageActions>
      <RevivnDatabaseDataGrid
        url="/location_management/movement_actions"
        syncStateWithSearchParams
        columns={[
          { field: "id", headerName: "ID", width: 90, filterable: false },
          {
            field: "fromLocationType.name",
            headerName: "From Location Type",
            width: 180,
            filterable: false,
            valueGetter: (params: GridValueGetterParams<MovementAction>) =>
              params.row.fromLocationType?.name || "Any Location Type",
          },
          {
            field: "toLocationType.name",
            headerName: "To Location Type",
            width: 180,
            filterable: false,
            valueGetter: (params: GridValueGetterParams<MovementAction>) => params.row.toLocationType?.name,
          },
          { field: "inventoryAttribute", headerName: "Inventory Attribute", width: 180 },
          { field: "modificationType", headerName: "Modification Type", width: 180 },
          { field: "modificationValue", headerName: "Modification Value", width: 180 },
          {
            field: "edit",
            headerName: "Edit",
            width: 120,
            sortable: false,
            filterable: false,
            ...linkColDef<MovementAction>(({ row }) => `/movement-actions/${row.id}/edit`),
          },
          {
            field: "delete",
            headerName: "Delete",
            width: 120,
            sortable: false,
            filterable: false,
            ...actionColDef<MovementAction>(
              ({ row }) => ({ method: "delete", action: `/movement-actions/${row.id}/delete` }),
              <Button
                type="submit"
                variant="outlined"
                color="error"
                size="small"
                onClick={(e) => {
                  if (!confirm("Are you sure you want to delete this movement action?")) {
                    e.preventDefault();
                  }
                }}
              >
                Delete
              </Button>,
            ),
          },
        ]}
        pageSize={25}
      />
    </FullPagePaperLayout>
  );
};

export default MovementActionList;
